import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationsContainer } from './components/notification/notification.component';
import { AnalyticsService } from 'src/modules/core/services';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'list',
  },
  {
    path: 'list',
    data: { title: "notification-list" },
    component: NotificationsContainer
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationRoutingModule {
  constructor(private analyticsService: AnalyticsService) {
    this.analyticsService.handleRouteEvents();
  }
}
